export const PLAN_IDS = {
  UNLIMITED: 'SM_UNLIMITED',
  DATA_ONLY_UNLIMITED: 'SM_UNLIMITED_DATAONLY',
  SM_FOUR_GB_PLAN: 'SM_4GB_NDD',
}
